import React, { useContext, useState } from "react";
import { SsdSettingsContext } from "./SsdSettingsContext";
import {
  grocery_charge_split_flag,
  grocery_enabled_flag,
  singles_flag,
} from "./SsdSettingsConstant";
import Toggle from "@amzn/meridian/toggle";
import { updateAdminSettings } from "./SsdSettingsNetworkAPI";
import { MODAL_ERROR, MODAL_SUCCESS } from "../SettingsConstant";
import { logOperationalMetric } from "../../../overview/utils/utils";
import { metricProcessName } from "../../../util/Constants";
import UpdateResponseModal from "./UpdateResponseModal";
import { getUserLogin } from "../../../resources/EmployeeResource";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

const General = (props) => {
  const { viewModel, dispatch } = useContext(SsdSettingsContext);
  const [adminSettings, setAdminSettings] = useState(
    viewModel.settingsData.adminSettings,
  );
  const [singles, setSingles] = useState(
    adminSettings && singles_flag in adminSettings
      ? adminSettings[singles_flag]
      : true,
  );

  const [grocery_enabled, setGroceryEnabled] = useState(
    adminSettings && grocery_enabled_flag in adminSettings
      ? adminSettings[grocery_enabled_flag]
      : false,
  );

  const [grocery_charge_split, setGroceryChargeSplit] = useState(
    adminSettings && grocery_charge_split_flag in adminSettings
      ? adminSettings[grocery_charge_split_flag]
      : {},
  );

  const setterFunctionsMap = {
    [singles_flag]: setSingles,
    [grocery_enabled_flag]: setGroceryEnabled,
    [grocery_charge_split_flag]: setGroceryChargeSplit,
  };

  const onChangeChargeSplit = (newValue, chargeName) => {
    setGroceryChargeSplit({
      ...grocery_charge_split,
      [chargeName]: parseFloat(newValue) || 0,
    });
  };

  const getVolumeSplitConfigLabel = (configKey) => {
    if (configKey.includes("ambient")) {
      return "Ambient";
    }

    if (configKey.includes("chilled")) {
      return "Chilled";
    }

    if (configKey.includes("frozen")) {
      return "Frozen";
    }

    return "";
  };

  const validateGroceryChargeSplit = (chargeSplit) => {
    const sum = Object.values(chargeSplit).reduce(
      (total, value) => total + parseFloat(value || 0),
      0,
    );
    return sum === 100;
  };

  const startTime = Date.now();
  const handleChange = async (newValue, flagName) => {
    setterFunctionsMap[flagName](newValue);
    const updatedAdminSettings = {
      ...adminSettings,
      [flagName]: newValue,
      lastUpdatedBy: await getUserLogin(),
      lastUpdatedAt: Math.round(Date.now() / 1000),
    };
    updateAdminSettings(updatedAdminSettings)
      .then((res) => {
        if (res.status === 200 && res.statusText === "OK") {
          setAdminSettings(updatedAdminSettings);
          dispatch({
            type: "UPDATE_ADMIN_SETTINGS",
            data: {
              adminSettings: updatedAdminSettings,
              showUpdatePlanResponseModal: MODAL_SUCCESS,
              messageToDisplay: `${flagName} flag updated successfully`,
            },
          });
          logOperationalMetric(
            startTime,
            metricProcessName,
            "updateSsdAdminSettings",
            true,
          );
        } else {
          dispatch({
            type: "UPDATE_ADMIN_SETTINGS",
            data: {
              adminSettings: adminSettings,
              showUpdatePlanResponseModal: MODAL_ERROR,
              messageToDisplay: `${flagName} flag update failed. Network error`,
            },
          });
          logOperationalMetric(
            startTime,
            metricProcessName,
            "updateSsdAdminSettings",
            false,
          );
        }
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_ADMIN_SETTINGS",
          data: {
            adminSettings: viewModel.settingsData.adminSettings,
            showUpdatePlanResponseModal: MODAL_ERROR,
            messageToDisplay: `${flagName} flag update failed`,
          },
        });
        logOperationalMetric(
          startTime,
          metricProcessName,
          "updateSsdAdminSettings",
          false,
        );
      });
  };

  return (
    <div>
      {grocery_enabled && Object.keys(grocery_charge_split).length > 0 && (
        <div>
          <Text
            tag="h3"
            type="h300"
            color="primary"
            style={{ marginTop: "20px", marginBottom: "10px" }}
          >
            Grocery Charge Split
          </Text>
          <div style={{ display: "flex", gap: "20px" }}>
            {Object.entries(grocery_charge_split).map(([configKey, _]) => (
              <Column key={getVolumeSplitConfigLabel(configKey)}>
                <Text tag="label" type="b200" color="primary">
                  {getVolumeSplitConfigLabel(configKey) + "%"}
                </Text>
                <Input
                  value={grocery_charge_split[configKey]}
                  onChange={(newValue) =>
                    onChangeChargeSplit(newValue, configKey)
                  }
                  type="number"
                  width={200}
                />
              </Column>
            ))}
            <Button
              size="small"
              alignmentHorizontal="right"
              onClick={() => {
                if (!validateGroceryChargeSplit(grocery_charge_split)) {
                  dispatch({
                    type: "UPDATE_ADMIN_SETTINGS",
                    data: {
                      adminSettings: adminSettings,
                      showUpdatePlanResponseModal: MODAL_ERROR,
                      messageToDisplay:
                        "Grocery charge split values must sum to 100%",
                    },
                  });
                  return;
                }
                handleChange(grocery_charge_split, grocery_charge_split_flag);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      )}
      <div style={{ marginTop: "20px" }}>
        <Toggle
          checked={singles}
          onChange={(newValue) => handleChange(newValue, singles_flag)}
          disabled={false}
        >{`Singles ${singles ? "On" : "Off"} by default`}</Toggle>{" "}
      </div>
      <UpdateResponseModal />
    </div>
  );
};

export default General;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/General.js